"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidEmail;
var VALID_EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

function isValidEmail(value) {
  return VALID_EMAIL_REGEX.test(value);
}